import React from 'react';

const MeasuresTab = ({ selected, measures, isMetricSelected }) => {
  if (!measures) {
    return null;
  }

  return (
    <div className={`tabbed-content-container${selected ? ' selected' : ''}`}>
      <h2>{measures.title}</h2>
      {measures.data.map((measure, index) => {
        if (!isMetricSelected(measure.metric)) {
          return null;
        }

        return (
          <div className="measure" key={index}>
            <img src={`${import.meta.env.VITE_IMAGES_BASE}${measure.image}`} alt={measure.alt} />
            <div dangerouslySetInnerHTML={{ __html: measure.caption }} />
            <table className="table-narrow">
              <tbody>
                {measure.dimensions.map((dim, dimIndex) => (
                  <tr key={dimIndex}>
                    <td>{dim.pos}</td>
                    <td>
                      <span>{dim.value}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  );
};

export default MeasuresTab;
